export const HOLIDAYS_TABLE_HEADERS = [
  { id: 1, title: 'Non-working/partly working days', value: 'date', sortType: 'string' },
  { id: 2, title: 'Duration', value: 'duration', sortType: 'string' },
  { id: 3, title: 'Reasons', value: 'title', sortType: 'string' },
];
